/* ==========================================================================
   VFLUO — Sticky add-to-cart mobile
   - Apparaît quand le bouton ATC principal sort du viewport (IntersectionObserver)
   - Clic = déclenche le vrai bouton [data-add-to-cart] (réutilise la logique
     variantes + ajax Impulse → ouvre le drawer + MAJ barre livraison)
   - Suit les changements de variante via l'event global 'variant:change'
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init() {
    var bar = document.querySelector('[data-vfluo-satc]');
    if (!bar) return;

    var sectionId = bar.getAttribute('data-product-section');
    var section = sectionId ? document.getElementById(sectionId) : null;
    if (!section) return;

    var realBtn = section.querySelector('[data-add-to-cart]');
    if (!realBtn) return;

    var stickyBtn = bar.querySelector('[data-vfluo-satc-btn]');
    var stickyBtnText = bar.querySelector('[data-vfluo-satc-btn-text]');
    var stickyPrice = bar.querySelector('[data-vfluo-satc-price]');
    var defaultLabel = stickyBtnText ? stickyBtnText.textContent.trim() : 'Ajouter au panier';

    // Clic sticky → clique le vrai bouton ATC (ajax Impulse fait le reste)
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (realBtn.disabled) return;
        realBtn.click();
      });
    }

    // Affiche/masque le sticky selon la visibilité du vrai bouton
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Le vrai bouton est visible → on masque le sticky (et inversement)
          if (entry.isIntersecting) {
            bar.classList.remove('vfluo-satc--visible');
          } else {
            bar.classList.add('vfluo-satc--visible');
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      observer.observe(realBtn);
    }

    // Cacher le sticky dès qu'un drawer Impulse s'ouvre.
    // Le CSS gère déjà l'affichage via html.js-drawer-open (posée par theme.Drawers).
    // On double avec un MutationObserver + l'event drawerOpen comme filet de sécurité.
    function syncDrawerState() {
      var open = document.documentElement.classList.contains('js-drawer-open');
      if (bar) bar.classList.toggle('vfluo-satc--drawer-open', open);
    }
    document.addEventListener('drawerOpen', syncDrawerState);
    if ('MutationObserver' in window) {
      new MutationObserver(syncDrawerState).observe(document.documentElement, {
        attributes: true, attributeFilter: ['class']
      });
    }

    // Suivi des changements de variante (prix + dispo + label)
    document.addEventListener('variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) {
        // Variante indisponible / introuvable
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }

      if (stickyPrice && typeof variant.price === 'number') {
        stickyPrice.textContent = formatMoney(variant.price);
      }

      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        if (stickyBtnText) {
          stickyBtnText.textContent = variant.available
            ? defaultLabel
            : (theme.strings && theme.strings.soldOut ? theme.strings.soldOut : 'Épuisé');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
